<template>
    <div>
        <PageTitle :title="$t('legal.titulo')"/>
        <FirstBanner/>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <p v-html="manager.legal"></p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';

    export default {
        data() {
            return {
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Legal',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }                         
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            PageTitle, FirstBanner
        }
    }
</script>
